import type AuthProvider from '$lib/components/auth/store.svelte';

export class GoogleAdsProvider {
	protected conversionId: string;
	protected conversionLabel: string;
	protected currency: string;
	protected auth: AuthProvider;

	constructor(googleAds: { id: string; label: string }, currency: string, auth: AuthProvider) {
		this.conversionId = googleAds.id;
		this.conversionLabel = googleAds.label;
		this.currency = currency;
		this.auth = auth;
	}

	#trackEvent(eventName: string, eventParams: Record<string, unknown> = {}) {
		gtag('event', eventName, eventParams);
	}

	#setData(dataType: string, data: Record<string, unknown>) {
		gtag('set', dataType, data);
	}

	trackConversion(order: SalesOrder, transactionId: string) {
		const userData = this.auth.userData;
		this.#setData('user_data', {
			email: userData?.hashedEmail,
			address: {
				first_name: order.shipping_address.firstname,
				last_name: order.shipping_address.lastname,
				street: order.shipping_address.street,
				city: order.shipping_address.city,
				region: order.shipping_address.region,
				postal_code: order.shipping_address.postcode,
				country: order.shipping_address.country_code,
			},
		});

		this.#trackEvent('purchase', {
			allow_custom_scripts: true,
			send_to: `AW-${this.conversionId}/${this.conversionLabel}`,
			value: order.grand_total,
			items: order.items.map((item) => ({
				sku: item.sku,
				quantity: item.quantity,
				price: item.unit_price,
			})),
			transaction_id: transactionId,
		});

		this.#trackEvent('conversion', {
			send_to: `AW-${this.conversionId}/${this.conversionLabel}`,
			value: order.grand_total,
			currency: this.currency,
			transaction_id: transactionId,
		});
	}
}

export default GoogleAdsProvider;
